import React, { useState, useEffect } from 'react';
import {
  TextField, Button, Box,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Grid,
  Paper
} from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { getJwtToken } from '../../services/jwt.services';
import ReactJson from "react-json-view"
import { useCompanyId } from '../../services/CompanyidProvider';
import LinearProgress from '@mui/material/LinearProgress';
import jwt_decode from 'jwt-decode';
import styles from './objectexplorer.module.css';
import ObjectExplorerService from '../../services/objectexplorer.services';
import Company from '../../components/company/company';
// TODO Move out to common file/DB
const objectTypes = [
  {value:"company", name:"Companies", disabled: false },
  {value:"newswire", name:"Newswire Distributions", disabled: false },
  {value:"nl2_newsletter", name:"NL 2.0 Newsletter", disabled: false },
  {value:"nl2_distribution", name:"NL 2.0 Distribution", disabled: false },
  {value:"recipientlist", name:"NL 2.0 Recipient List", disabled: false },
  {value:"outreach", name:"Outreach Emails", disabled: false },
  {value:"user", name:"Users", disabled: false },
  {value:"engage_publish_message", name:"Engage Publish Message", disabled: false },
  // {value:"classicdashboard", name:"Classic Dashboard", disabled: false },
  // {value:"dashboard_report_definition", name:"Dashboard Report Definitions", disabled: false },
  // {value:"dashboard_report", name:"Dashboard Reports", disabled: false },
  // {value:"dashboard", name:"Dashboard", disabled: false },
  // {value:"dashboard", name:"Dashboard", disabled: false },
  // {value:"document", name:"Documents", disabled: false },
  // {value:"email", name:"Emails", disabled: false },
  // {value:"excel_export_v2", name:"Excel Exports V2", disabled: false },
  // {value:"excel_export", name:"Excel Exports", disabled: false },
  // {value:"newsfeed", name:"Newsfeeds", disabled: false },
  // {value:"newsletter_distribution", name:"Newsletter Distributions", disabled: false },
  // {value:"newsletter_template", name:"Legacy Newsletter Templates", disabled: false },
  // {value:"newsletter", name:"Newsletters", disabled: false },
  // {value:"newswire_organization", name:"Newswire Organizations", disabled: false },
  // {value:"recipient_list", name:"NL Recipient Lists", disabled: false },
  // {value:"recipientlist", name:"Legacy NL Recipient Lists", disabled: false },
  // {value:"report_definition", name:"Digest Report Definitions", disabled: false },
  // {value:"report", name:"Digest Reports", disabled: false },
  // {value:"reporting_emails", name:"Excel Emails", disabled: false },
  // {value:"search", name:"Searches", disabled: false },
  // {value:"source", name:"Sources", disabled: false },
  // {value:"subscription", name:"Subscriptions", disabled: false },
]

export default function GetObject() {
  const [object, setObject] = useState('');
  const { companyId } = useCompanyId();
  const [selectedId, setSelectedId] = useState('');
  const [objectType, setObjectType] = useState(objectTypes[0]);
  const [permissions, setPermissions] = useState([]);
  const [isFetching, setIsFetching] = useState([]);

  useEffect(() => {
    const jwtToken = getJwtToken();
    setObjectType(objectTypes[0])

    setIsFetching(false)
    if (jwtToken) {
      const { permissions } = jwt_decode(jwtToken);
      setPermissions(permissions);
      console.log("PERMISSIONS ", permissions)
    }
  }, [companyId]);

  const handleSubmit = async () => {
    setIsFetching(true)
    let returnedObject;
    try {
      returnedObject = await ObjectExplorerService.getObject(companyId, objectType.value, selectedId)
      setObject(returnedObject.data)
    }
    catch {}
    setIsFetching(false)
  };

  if (!permissions || !permissions.includes('read')) {
    // If user does not have permission, you can render a message, redirect, or display a different component
    return <div>You do not have permission to access this page.</div>;
  }


  return (
    <>
      <Company />
      
      <div className={styles.container}>
        <div className={styles.headerContainer}>
          <div className={styles.headerRow}>
            <Button 
              className={styles.backButton}
              onClick={() => window.history.back()}
              startIcon={<ArrowBackIcon />}
            >
              Back
            </Button>
            <h1 className={styles.pageTitle}>Object Explorer</h1>
          </div>
          <p className={styles.pageSubtitle}>View and explore Meltwater objects</p>
        </div>

        <Paper className={styles.contentPaper}>
        <Box sx={{ mb: 3 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6} md={4}>
              <FormControl fullWidth required variant="outlined">
                <InputLabel id="object-type-label">Object Type</InputLabel>
                <Select
                  labelId="object-type-label"
                  id="object-type"
                  value={objectType}
                  label="Object Type"
                >
                  {objectTypes.map((element, idx) => (
                    <MenuItem 
                      key={idx} 
                      onClick={() => setObjectType(element)} 
                      value={element}
                    >
                      {element.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <TextField 
                fullWidth
                id="object-id" 
                label="Object ID" 
                variant="outlined" 
                onChange={(evt) => setSelectedId(evt.target.value)}
                value={selectedId}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={4}>
              <Button 
                fullWidth
                variant="contained"
                onClick={handleSubmit} 
                disabled={selectedId.length === 0}
                className={styles.submitButton}
                sx={{ height: '56px' }}
              >
                Get Object
              </Button>
            </Grid>
          </Grid>
        </Box>

        {isFetching && (
          <Box sx={{ width: '100%', mb: 2 }}>
            <LinearProgress />
          </Box>
        )}

        {object && !isFetching && (
          <Box className={styles.jsonContainer}>
            <ReactJson 
              src={object} 
              collapsed={false} 
              displayDataTypes={false} 
              name={false}
              theme="rjv-default"
              style={{ 
                padding: '16px', 
                borderRadius: '8px',
                backgroundColor: '#f8f9fa'
              }}
            />
          </Box>
        )}
      </Paper>
    </div>
    </>
  );
}
